// modules/house-and-land/HouseAndLand.js
import React              from 'react';
import $                  from 'jquery';
import PageLoading        from '../PageLoading';
import PackageSearchBar from './elements/PackageSearchBar';
import PackageSearchSorting    from '../common/PackageSearchSorting';
import PackageSearchGrid from './elements/PackageSearchGrid';
import PackageSearchList from './elements/PackageSearchList';


const sources = require('../config.json');

class HouseAndLand extends React.Component {
	constructor(props) {
		super(props);
		this.packagesearch_url = sources.packagesearch;

		let view = 'grid';
        if (window.matchMedia('(max-width: 768px)').matches) {
            view = 'list';
        }

		this.state = {
			view: view,
			data: {},
			packages: [],
            packagesFiltered: [],
            packagesSorted: [],
			sort: null,
            displayCount: 0
		};

        this.onSearchUpdate = this.onSearchUpdate.bind(this);
        this.onSearchReset = this.onSearchReset.bind(this);
        this.onSortUpdate = this.onSortUpdate.bind(this);
        this.onViewSwitch = this.onViewSwitch.bind(this);
        this.viewSwitcher = this.viewSwitcher.bind(this);
        this.filterByPrice = this.filterByPrice.bind(this);
        this.filterByArea = this.filterByArea.bind(this);
	}

	componentDidMount() {
		let packageSearch =  $.ajax({url: this.packagesearch_url,dataType:'json'});
		$.when(packageSearch).done(function(data) {
			let newState = Object.assign(this.state, {
				data: data,
				packages: data.s_packages,
                packagesFiltered: data.s_packages,
                packagesSorted: data.s_packages,
                displayCount: 0
			});
			this.setState(newState);
		}.bind(this));
	}

    onSearchUpdate(data) {
        $('.btn__filter-search').addClass('searching-active');
        let packagesFiltered = this.state.packages;
        packagesFiltered = this.filterByPrice(data.price, packagesFiltered);
        packagesFiltered = this.filterByArea(data.area, packagesFiltered);
        if(data.builder !== '' && parseInt(data.builder,10) !== 0 ) {
        	packagesFiltered = this.filterByBuilder(data.builder, packagesFiltered);
        }
        if(data.bed !== null) {
        	packagesFiltered = this.filterByBedroom(data.bed, packagesFiltered);
        }
        if(data.bath !== null) {
        	packagesFiltered = this.filterByBathroom(data.bath, packagesFiltered);
        }
        if(this.state.sort !== null) {
            let newState = Object.assign(this.state, {
                packagesFiltered: packagesFiltered
            });
            this.setState(newState);
            this.onSortUpdate(this.state.sort.type, this.state.sort.direction);
        } else {
            let newState = Object.assign(this.state, {
                packagesFiltered: packagesFiltered,
                packagesSorted: packagesFiltered
            });
            this.setState(newState);
        }
        setTimeout(() => { $('.btn__filter-search').removeClass('searching-active'); }, 1000);
	}

    onSearchReset() {
        if(this.state.sort !== null) {
            let newState = Object.assign(this.state, {
                packagesFiltered: this.state.packages
            });
            this.setState(newState);
            this.onSortUpdate(this.state.sort.type, this.state.sort.direction);
        } else {
            let newState = Object.assign(this.state, {
                packagesFiltered: this.state.packages,
                packagesSorted: this.state.packages
            });
            this.setState(newState);
        }
	}

    onSortUpdate(type, direction) {
        let tempArr = this.state.packagesFiltered;
        switch(direction) {
            case 'asc':
                tempArr.sort((a, b) => { return a[type] - b[type]; });
                break;
            case 'dsc':
                tempArr.sort((a, b) => { return b[type] - a[type]; });
                break;
            default:
        }
        let newState = Object.assign(this.state, {
            packagesSorted: tempArr,
            sort: {
                type: type,
                direction: direction
            }
        });
        this.setState(newState);
    }

    onViewSwitch(view) {
        if (view !== this.state.view) {
            let newState = Object.assign(this.state, {
                view: view
            });
            this.setState(newState);
        }
    }

    filterByPrice(price, packages) {
        return packages.reduce(function (accum, thisPackage) {
            if (thisPackage.price >= price.start && thisPackage.price <= price.end)
                accum.push(thisPackage);
            return accum;
        }, []);
    }

    filterByArea(area, packages) {
        return packages.reduce(function (accum, thisPackage) {
            if (thisPackage.area >= area.start && thisPackage.area <= area.end)
                accum.push(thisPackage);
            return accum;
        }, []);
    }

    filterByBuilder(builder, packages) {
        return packages.reduce(function (accum, thisPackage) {
            if (parseInt(thisPackage.builder_id, 10) === parseInt(builder, 10))
                accum.push(thisPackage);
            return accum;
        }, []);
	}

    filterByBedroom(bed, packages) {
        return packages.reduce(function (accum, thisPackage) {
            if (parseInt(thisPackage.bed, 10) >= parseInt(bed, 10))
                accum.push(thisPackage);
            return accum;
        }, []);
	}

    filterByBathroom(bath, packages) {
        return packages.reduce(function (accum, thisPackage) {
            if (parseInt(thisPackage.bath, 10) >= parseInt(bath, 10))
                accum.push(thisPackage);
            return accum;
        }, []);
	}

    viewSwitcher() {
	    if(this.state.packagesSorted.length === 0) {
            return ( <p className="m-b-0 p-a-1 release-title tc">No search results found matching your criteria.</p> )
        }
        if (this.state.view === 'list') {
            return ( <PackageSearchList data={this.state.packagesSorted}/> )
        }
        if (this.state.view === 'grid') {
            return ( <PackageSearchGrid data={this.state.packagesSorted}/> )
        }
    }

	render() {
        if (typeof this.state.data.s_packages !== "undefined") {
			return (
				<div className="App">
                    <section className="section p-t-2">
                        <div className="container">
                            <div className="section__content ">
                                <h1 className="title f3 f4-md f-headline-lg m-b-4 m-b-4-md tc">House & Land Packages</h1>
					            <PackageSearchBar onSearchClick={this.onSearchUpdate} onResetClick={this.onSearchReset} search={this.props.location.query}/>
                            </div>
                        </div>
                    </section>
					<section className="section p-h-1 p-h-3-lg section-bg-white land-filter-section">
						<div className="container">
							<PackageSearchSorting onSort={this.onSortUpdate} onSwitch={this.onViewSwitch} view={this.state.view} search={this.props.location.query}/>
                            {this.viewSwitcher()}
						</div>
					</section>
				</div>
			);
		} else {
            return (
                <div className="App">
                    <PageLoading>House and Land</PageLoading>
                </div>
            )
		}
	}
}

export default HouseAndLand;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/HouseAndLand.js
 **/